import axios, { bsHost, parseKeyValueCollection } from "apis/config";

type blockApiProps = {
  "SKPAd-UUID"?: string;
  campaign_id: number;
  campaign_name?: string;
  device_id: number;
  vd_id?: string;
  ifa?: string;
  ifv?: string;
  app_id: number;
  unit_id: number;
  adnetwork_campaign_id?: string;
  is_allow: boolean;
};

const caApi = {
  block: (payload: blockApiProps) => {
    return axios.post(`${bsHost}/api/block/ads`, parseKeyValueCollection(payload));
  },
};

export default caApi;
export type { blockApiProps };
